<template>
  <div :id="`modal-${modalId}`">
    <MadModal
      :id="modalId"
      :data-cy="`${modalId}-modal`"
      :options="options"
      @opened="onOpened"
      @closed="onClosed"
    >
      <div class="modal-body">
        <b-tabs
          v-model="tabIndex"
          no-key-nav
        >
          <template>
            <b-tab :title="`${this.$i18n.t('JSON.posts')}`">
              <div class="v-table">
                <TableServer type="posts" />
              </div>
            </b-tab>
            <b-tab :title="`${this.$i18n.t('JSON.add-post')}`">
              <PostForm v-if="fetcherAdminSchemas.forms['Post']" />
            </b-tab>
            <b-tab
              v-if="postId !== null && fetcherAdminPost.pid !== ''"
              :title="`${this.$i18n.t('JSON.post')}#${postId}`"
            >
              <!-- <PostForm -->
              <!-- v-if="fetcherAdminSchemas.forms['Post']" -->
              <!-- :post="fetcherAdminPost" -->
              <!-- mode="edit" -->
              <!-- /> -->

              <Debug
                :expanded="true"
                :force-show="true"
                :label="`${this.$i18n.t('JSON.post')}#${postId}`"
                :data="fetcherAdminPost"
              />
            </b-tab>
          </template>
        </b-tabs>
      </div>
    </MadModal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import formHelpers from '@/mixins/admin/helpers/form-helpers';
import modalHelpers from '@/mixins/admin/helpers/modal-helpers';

export default {
  components: {
    PostForm: () => import('@/components/admin/fetcher/modals/forms/PostForm'),
    MadModal: () => import('@/components/MadModal'),
  },

  mixins: [
    formHelpers, //
    modalHelpers,
  ],

  props: {
    postId: {
      type: String,
      default: () => '',
    },
  },

  data() {
    return {
      options: {
        width: '75%',
        //   height: '95%',
      },
    };
  },

  computed: {
    ...mapState({
      fetcherAdminPost: (state) => state.fetcherAdminPost.fetcherAdminPost,
    }),

    modalId() {
      return 'post';
    },
  },

  watch: {
    postId(newValue) {
      if (newValue !== null) {
        this.loadFetcherAdminPost();
      }
    },
  },

  methods: {
    ...mapActions(['getFetcherAdminPost']),

    async loadFetcherAdminPost() {
      try {
        await this.getFetcherAdminPost({
          params: {
            pid: this.postId,
          },
        });

        // console.log('post', this.post);

        // success
        // console.log('success loading post!');
      } catch (error) {
        // error
        // console.log('error loading post!');
      }
    },

    onOpened() {
      if (this.postId !== null) {
        this.loadFetcherAdminPost();
      }

      this.modalOpened();
    },

    onClosed() {
      this.modalClosed();
    },
  },
};
</script>
